import { ProjectWithSlideshow } from "@/components/projects-components-sharedwithstaticsite/types";
import projects_meta_info from "./projects_meta_info.json";

// export const project_meta_info: { id: string; title: string; href: string; active: boolean; description: string }[] = [
//     // {
//     //     title: 'ChatOps',
//     //     active: true,
//     //     href: '/projects/chatops-overview',
//     //     description:
//     //         'Deploy infrastructure, get advice, or find entertaining videos using live chat!',
//     // },
//     {
//         id: "portfolio-website",
//         title: "Portfolio Website",
//         description: "My portfolio website built with Next.js, TypeScript, shad-cn, and Tailwind CSS.",
//         active: true,
//         href: "https://johannahendrix.com",
//     },
//     {
//         id: "ai-job-matcher",
//         title: "AI job matcher",
//         active: true,
//         href: "/ai-interview-step1",
//         description: "Match job descriptions instantly against my background and interests; interview my virtual twin",
//     },
//     {
//         id: "roadtrip-mapper",
//         title: "Roadtrip videos, mapped",
//         active: true,
//         href: "/projects-d/roadtrip-mapper",
//         description: "Search a wealth of k8s info in this unofficial CNCF video archive",
//     },
//     {
//         id: "osm-proximity-search",
//         title: "Proximity Search",
//         href: "/projects-d/osm-proximity-search",
//         active: true,
//         description:
//             "Advanced map search. E.g. find all Starbucks locations with a fitness studio next to them. (Also great for identifying where photos were taken.)",
//     },
//     {
//         id: "worldwide-video-map",
//         title: "Worldwide Video Search",
//         active: true,
//         href: "/projects-d/video-map",
//         description: "Tired of the same ol' YouTube search results? Find videos from small(ish) international creators",
//     },
//     // {
//     //     title: '"In the style of" famous artists',
//     //     active: true,
//     //     href: '/projects/famous-painters-AI-imitations',
//     //     description:
//     //         'Collection of AI art imitating Van Gogh, Michelangelo, Roy Lichtenstein and many others',
//     // },
//     // {
//     //     title: 'Memeable clips',
//     //     active: true,
//     //     href: '/projects/memeable-clips',
//     //     description:
//     //         'Find memeable clips in videos',
//     // },
//     {
//         id: "cloudrightsizing-it-blog",
//         title: "Blog about cloud topics",
//         href: "/cloudrightsizing-blog",
//         active: true,
//         description: "Markdown blog about cloud topics. Mostly AI-generated, but with some personal touches.",
//     },

//     {
//         id: "tierlist-generator",
//         title: "Tierlist generator",
//         href: "/projects-d/tierlist",
//         active: true,
//         description: "Create beautiful tierlists from videos",
//     },
//     {
//         id: "ai-images-in-style-of",
//         title: `AI images "in style of"`,
//         href: "/projects-d/search/artist-styles-according-to-ai",
//         active: false,
//         description: "Search of AI images generated using real artist styles, by random internet users",
//     },
//     // {
//     //     title: 'Git inspector',
//     //     href: '/projects/git-inspector',
//     //     active: false,
//     //     description:
//     //         'What are power users building with your favorite frameworks? Unearth hidden gems from within git issues',
//     //     // Some of the best code samples are hidden in git issues.See what power devs are building with your favorite frameworks!
//     // },
//     // {
//     //     title: 'AI LinkedIn Profile Pictures',
//     //     href: '/projects/ai-profile-pictures',
//     //     active: true,
//     //     description:
//     //         'Sometimes one needs virtual-but-realistic headshots (for demo sites etc.). Find yours for free here!',
//     // },
//     // {
//     //     title: 'Cool Zoom meeting backgrounds',
//     //     href: '/projects/ai-cool-remote-meeting-backgrounds',
//     //     active: true,
//     //     description:
//     //         'Cool AI-generated meeting backgrounds for virtual meetings. Free, no watermark',
//     // },
//     {
//         id: "meowimages",
//         title: "MeowImages.com",
//         href: "https://meowimages.com",
//         active: true,
//         description:
//             "AI stock image site, based on other people's image generations. For research, fun, and inspiration.",
//     },
//     {
//         id: "azure-TTS-voices",
//         title: "Azure TTS voice samples",
//         href: "/projects-d/azure-TTS-voices",
//         active: true,
//         description:
//             "For some strange reason it can be hard to find samples for Azure TTS voices (as of Aug 2024), so I created my own.",
//     },
//     {
//         id: "cncf-archive",
//         title: "CNCF Archive",
//         active: true,
//         href: "/projects-d/search/cncf-videos",
//         description: "Search a wealth of k8s info in this unofficial CNCF video archive",
//     },
//     {
//         id: "aws-videos",
//         title: "AWS videos",
//         href: "/projects-d/search/aws-videos",
//         active: true,
//         description: "Deep search of the AWS cloud video repository. Find on-topic videos for specific challenges!",
//     },

//     {
//         id: "microsoft-azure-videos",
//         title: "Microsoft videos",
//         href: "/projects/microsoft-video-search",
//         active: true,
//         description:
//             "Deep search of the Microsoft/Azure cloud video repository. Find on-topic videos for cloud and general development challenges!",
//     },
//     // {
//     //     title: 'Bad Logos',
//     //     active: true,
//     //     href: '/projects/bad-AI-logos',
//     //     description:
//     //         "View AI-generated logos, by topic! Helpful to tell your designer what you DON'T want",
//     // },

//     // {
//     //     id: "about-my-trip",
//     //     title: "About My Trip",
//     //     href: "/projects/about-my-trip",
//     //     active: false,
//     //     description: "My U.S. road trip - recorded & mapped",
//     // },

//     // {
//     //     title: 'Image/Text collages',
//     //     href: '/projects/image-collages',
//     //     active: false,
//     //     description:
//     //         'Auto-collages (image/text) - another old project that I plan to migrate',
//     // },
//     // {
//     //     title: 'Care.com alternative',
//     //     href: '#',
//     //     active: false,
//     //     description:
//     //         'I tried to sign up with Care.com to make some extra money. That site is just mind-bogglingly buggy and lacks crucial featrur and user-unfriendly (especially for providers). ',
//     // },

//     // {
//     //     title: 'Cloud News',
//     //     href: '/projects/cloud-news',
//     //     active: true,
//     //     description:
//     //         'Using my custom video recording dashboard to present cloud videos on YouTube',
//     // },
// ];

// export const projects: ProjectWithSlideshow[] = [
//     {
//         id: "portfolio-website",
//         title: "Portfolio Website",
//         description: "My portfolio website built with Next.js, TypeScript, shad-cn, and Tailwind CSS.",
//         // image: "/images/profile.webp",
//         videoUrl: `portfolio-website.mp4`,
//         note: "active",
//         status: {
//             text: "(This very site)",
//             link: "https://johannahendrix.com",
//             icon: null as string | null, // "icon-[tabler--arrow-right]",
//         },
//         isFeatured: true,
//         tags: [],
//         technologiesUsed: ["Next.js", "TypeScript", "shad-cn", "Tailwind CSS"],
//         isFullWidth: false,
//         rotatingSlidesCount: 8,
//         featuredScreenshotIndex: 1,
//     },
// ];

// projects.push({
//     title: "IT songs",
//     description: "Just some fun IT-themed AI songs",
//     image: "/images/profile.webp",
//     note: "a great note",
//     status: {
//         text: "See in Action",
//         link: "/IT-songs",
//         icon: "icon-[tabler--arrow-right]",
//     },
//     isFeatured: true,
//     isFullWidth: false,
// });

export const projects: ProjectWithSlideshow[] = [];

projects.push(
    ...projects_meta_info
        .filter((z) => z.active)
        .map((z) => ({
            id: z.id,
            title: z.title,
            description: z.description,
            // image: "/images/profile.webp",
            videoUrl: `${z.id}.mp4`,
            note: "active",
            status: {
                text: "See in Action",
                link: z.href,
                icon: "icon-[tabler--arrow-right]",
            },
            isFeatured: z.featured,
            tags: [],
            technologiesUsed: ["Next.js", "TypeScript", "shad-cn", "Tailwind CSS"],
            isFullWidth: false,
            rotatingSlidesCount: 8,
            featuredScreenshotIndex: z.featuredScreenshotIndex ? z.featuredScreenshotIndex : 1,
        })),
);

// console.log(JSON.stringify(project_meta_info, null, 2));
